import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { ApiUrl } from "../../API/Api.config";
import image1 from '../../assets/images/login/login.jpg';
import { useEffect } from "react";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const PasswordReset = () => {
    document.title = "Password Reset | PROMOTE"

    // const ENVIRONMENT = 1

    // if (ENVIRONMENT === 1) {
    //     console.log = () => { }
    //     console.error = () => { }
    //     console.debug = () => { }
    // }

    const [email, setEmail] = useState(true)
    const [otp, setOtp] = useState(false)
    const [getEmail, setGetEmail] = useState("")
    const MySwal = withReactContent(Swal)
    const [loading, setLoading] = useState(false);

    async function ResetPassword(email) {
        setLoading(true)
        try {
            await axios.get(ApiUrl + `account_reset/${email}/`,
                {
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                    }
                })
                .then(function (response) {
                    if (response.status === 200) {
                        setEmail(false);
                        setOtp(true)

                        MySwal.fire({
                            position: 'top',
                            toast: true,
                            icon: 'success',
                            title: 'Password reset email has been sent',
                            showConfirmButton: false,
                            timer: 3000,
                        })

                    };
                })
                .catch(function (error) {

                    MySwal.fire({
                        position: 'top',
                        toast: true,
                        icon: 'error',
                        title: 'Something went wrong, please try again later',
                        showConfirmButton: false,
                        timer: 3000,
                    })

                }).finally(() => (
                    setLoading(false)
                ));
        } catch (error) {
            console.log(error)

        }

    };

    async function ResetPasswordPost(email, data) {
        setLoading(true)
        try {
            await axios.post(ApiUrl + `account_reset/${(email)}/`, data,
                {
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    }
                })
                .then(function (response) {
                    MySwal.fire({
                        position: 'top',
                        toast: true,
                        icon: 'success',
                        title: 'Password has been reset',
                        showConfirmButton: false,
                        timer: 2000,
                    })

                    setTimeout(() => { 
                        window.location.href = 'fb851990559613106://app'
                     }, 2000)
                })
                .catch(function (error) {
                    MySwal.fire({
                        position: 'top',
                        toast: true,
                        icon: 'error',
                        title: 'Something went wrong, please try again later',
                        showConfirmButton: false,
                        timer: 3000,
                    })
                    
                }).finally(() => (
                    setLoading(false)
                ));
        } catch (error) {
            if (error.request.status === 400) {
                MySwal.fire({
                    position: 'top',
                    toast: true,
                    icon: 'error',
                    title: 'Something went wrong, please try again later',
                    showConfirmButton: false,
                    timer: 3000,
                })
            }

        }

    };

    // useEffect(() => { }, [email, otp])
    useEffect(() => {
        console.log(getEmail)
    }, [getEmail])

    const { register, handleSubmit, formState: { errors } } = useForm();

    const handleSubmitForm = (e) => {
        e.preventDefault()
        ResetPassword(getEmail)
    }

    const handleSubmitOtp = (data) => {
        ResetPasswordPost(getEmail, data)
    }


    return (

        <>
            <div className="absolute mt-4 hidden " id="errorToast">
                <div id="toast-default" className="flex items-center p-4 w-full max-w-xs text-white bg-red-700 rounded-lg shadow" role="alert">
                    <div className="text-sm font-bold">
                        Login Unsuccessful
                    </div>
                </div>
            </div>
            <div className="relative flex flex-col justify-center min-h-screen">
                <div className="py-6 h-[870px]">
                    <div className="flex bg-white rounded-lg border shadow-lg overflow-hidden mx-auto max-w-sm lg:max-w-[75rem] h-full">
                        <div className="hidden lg:block lg:w-1/2 bg-cover auth-image" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(" + image1 + ")" }}></div>
                        <div className="w-full p-6 lg:w-1/2 flex flex-col justify-center">
                            <p className="text-xl text-gray-600 text-center"><small>Welcome back to</small></p>
                            <h1 className="text-2xl font-semibold text-gray-700 text-center">PROMOTE</h1>

                            <div className="mt-4 flex items-center justify-between">
                                <span className="border-b w-1/5 lg:w-1/4"></span>
                                <a href="#" className="text-xs text-center text-gray-500 uppercase">Reset your password</a>
                                <span className="border-b w-1/5 lg:w-1/4"></span>
                            </div>
                            {email && <form onSubmit={handleSubmitForm}>
                                <label htmlFor="email" className="block text-sm text-gray-800">E-mail</label>
                                <input type="email" name="email" onChange={(e) => { setGetEmail(e.target.value) }} className="block w-full px-4 py-2 mt-2 text-black-700 bg-white border rounded-lg focus:border-black-400 focus:ring-black-300 focus:outline-none focus:ring focus:ring-opacity-40" />

                                <button
                                    className="flex justify-center items-center w-full px-4 py-2 mt-4 tracking-wide text-white transition-colors duration-200 transform bg-primary rounded-lg hover:bg-black focus:outline-none focus:bg-black">
                                    {loading == false &&
                                        <>Send Reset Email</>
                                    }
                                    {loading == true &&
                                        <div role="status">
                                            <svg aria-hidden="true" className="w-6 h-6 mr-2 text-gray-200 animate-spin fill-primary" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                            </svg>
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    }
                                </button>
                            </form>}
                            {otp && <form onSubmit={handleSubmit(handleSubmitOtp)}>
                                <label htmlFor="otp" className="block text-sm text-gray-800">Code on Email</label>
                                <input type="number" name="otp" {...register('otp', { required: 'OTP is required' })} className="block w-full px-4 py-2 mt-2 text-black-700 bg-white border rounded-lg focus:border-black-400 focus:ring-black-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                                {errors.otp && (
                                    <div className="mb-3 text-normal text-red-500">
                                        {errors.otp.message}
                                    </div>
                                )}
                                <label htmlFor="otp" className="block text-sm text-gray-800 mt-3">New Password</label>
                                <input type="password" name="password" {...register('password', { required: 'password is required' })} className="block w-full px-4 py-2 mt-2 text-black-700 bg-white border rounded-lg focus:border-black-400 focus:ring-black-300 focus:outline-none focus:ring focus:ring-opacity-40" />
                                {errors.password && (
                                    <div className="mb-3 text-normal text-red-500">
                                        {errors.password.message}
                                    </div>
                                )}
                                <button
                                    className="flex justify-center items-center w-full px-4 py-2 mt-4 tracking-wide text-white transition-colors duration-200 transform bg-primary rounded-lg hover:bg-black focus:outline-none focus:bg-black">
                                    {loading == false &&
                                        <>Reset Password</>
                                    }
                                    {loading == true &&
                                        <div role="status">
                                            <svg aria-hidden="true" className="w-6 h-6 mr-2 text-gray-200 animate-spin fill-primary" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                            </svg>
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    }
                                </button>
                            </form>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordReset;
